import Vue from 'vue'
import { cacheState, cachedState } from '../utils'

const state = cachedState({
  availableCategories: null,
  category: null,
  template: null
})

const getters = {
  categories (state) {
    return state.availableCategories && state.availableCategories.categories
  },

  emptyTemplate (state) {
    return state.availableCategories && state.availableCategories.emptyTemplate
  }
}

const mutations = {
  setCategories (state, categories) {
    state.availableCategories = categories
    cacheState(state)
  },

  setCategory (state, category) {
    state.category = category
    cacheState(state)
  },

  setTemplate (state, template) {
    state.template = template
    cacheState(state)
  },

  reset (state) {
    state.availableCategories = null
    state.category = null
    state.template = null
    cacheState(state)
  }
}

const actions = {
  async getCategories ({ state, commit }) {
    if (state.availableCategories) {
      return state.availableCategories
    }

    const categories = await Vue.api.getCategories()
    commit('setCategories', categories)
    return categories
  },

  chooseCategory ({ commit, dispatch }, category) {
    commit('setCategory', category)
    return dispatch('proceed', null, { root: true })
  },

  chooseTemplate ({ commit, dispatch }, template) {
    commit('setTemplate', template)
    return dispatch('proceed', null, { root: true })
  },

  chooseEmptyTemplate ({ commit, dispatch, getters }) {
    commit('setCategory', null)
    commit('setTemplate', getters.emptyTemplate)
    return dispatch('proceedToFinal', null, { root: true })
  },

  createWebsite ({ commit, dispatch, state }, params) {
    return Vue.api.signup({
      ...params,
      templateId: state.template && state.template.id
    })
  },

  reset ({ commit }) {
    commit('reset')
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/create-flow.js